<template>
    <div class="login-container"
        v-loading="true"
        element-loading-text="系统加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)">
    </div>
</template>

<script>
    import { globalConfig } from 'static/config'

    export default {
        name: 'autoLogin',
        data() {
            return {
                xToken: null,
                user: null,
                name: null,
                error: null,
                src:globalConfig.CASURL + '/logout',
            }
        },
        mounted() {
            this.autoLogin();
        },
        methods: {
            getWechatAuthCode(){
                const url = window.location.href;
                const index = url.indexOf('?');
                let code = '';

                if(index > -1){
                    const queryStr = url.substring(index + 1);
                    const codeParam = queryStr.split('&')[0];

                    if(codeParam.substring(0, 4) === 'code'){
                        code = codeParam.substring(5);
                        code = code.replace('#/m/wx/login', '');
                    }
                }

                return code;
            },
            autoLogin(){
                const code = this.getWechatAuthCode();

                if(code === ''){
                    this.$router.push('/m/home');
                }else{
                    this.autoLogin4Wx(code);
                }
            },
            //微信访问自动登录
            autoLogin4Wx(code){
                this.$api.system.basic.autoLogin4Wx({
                    data: { code: code }
                }).then((res) => {
                    const data = res.data.data;
                    if(data.state === 'Success'){
                        localStorage.setItem('x-token', data.userToken);
                        localStorage.setItem('user', data.userCode);
                        localStorage.setItem('name', data.userName);
                        this.$router.push(localStorage.getItem('wechat_topath'));
                    }else{
                        this.$router.push('/m/home');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            }
        }
    }
</script>
<style>
    .login-container {
        width: 100vw;
        height: 100vh;
    }
</style>



// WEBPACK FOOTER //
// autoLogin.vue?4eba40b8